<template>
  <div :style="{'background-color':background_color}">
    <div class="container">
      <div class="text-center m-4">
        <img width="150px" :src="logo_url" alt="logo">
      </div>
      <h2 class="text-white text-center m-4">{{ app_name }}</h2>
      <h2 class="text-white text-center m-4">Mapa de vagas</h2>
      <div class="row m-2">
        <div class="div-terms">
          <vue-dynamic-map id="map" :centerOv="center" :markerList="markersList" :polygonList="polygonsList"
                           v-if="markers.length > 0">
          </vue-dynamic-map>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import VueDynamicMap from "../components/VueDynamicMap.vue";
import axios from 'axios';

export default {
  components: {VueDynamicMap},
  data: function () {
    return {
      profiles: [],
      markers: [],
      polygons: [],
      size: 200,
    }
  },
  mounted() {
    this.handleProfilesData();
    this.handleSpotsData();
    this.handleSectorsData();
  },
  methods: {
    async handleProfilesData() {
      try {
        const {data: {data}} = await axios.get('/api/public/demarcation/parking/active-profiles');
        this.profiles = data;
      } catch (e) {
        window.alert(e.response.data.message);
      }
    },
    async handleSpotsData() {
      try {
        const {data: {data}} = await axios.get('/api/public/demarcation/spot');
        this.markers = data.map(spot => (
            {
              url: this.getSvgIconUrl(this.getProfileIconBySpot(spot), this.getProfileColorBySpot(spot)),
              infoText: '<div id="content">' +
                  '<div id="bodyContent">' +
                  '<p>' + 'Vaga:' + spot.name + '</p>' +
                  '<p>' + 'Perfil:' + spot.parking_profile + '</p>' +
                  '</div>' +
                  '</div>',
              position: {
                lat: Number(spot.center.coordinates[1]),
                lng: Number(spot.center.coordinates[0])
              }
            }
        ))
      } catch (e) {
        window.alert(e.response.data.message);
      }
    },
    async handleSectorsData() {
      try {
        const {data: {data}} = await axios.get('/api/public/demarcation/sector');
        this.polygons = data
            .filter((sector) => sector.polygon)
            .map((sector) => ({
              ...sector.polygon,
              header: `Setor: ${sector.name}`,
              name: sector.name,
              center: sector.center,
              color: sector.color || "rgba(0,4,232,0.8)",
            }));
      } catch (e) {
        window.alert(e.response.data.message);
      }
    },
    getProfileIconBySpot(spot) {
      const profile = this.profiles.find(profile => profile.name === spot.parking_profile);

      if (profile && profile.icon) {
        return profile.icon;
      }
    },
    getProfileColorBySpot(spot) {
      const profile = this.profiles.find(profile => profile.name === spot.parking_profile);

      if (profile && profile.color) {
        return profile.color;
      }
    },
    getSvgIconUrl(iconName, color = '#0000FF') {
      const svg = `
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 640 640" width="20" height="20">
            <path fill="${color}" d="${this.getIconPath(iconName)}"/>
        </svg>
    `;

      return 'data:image/svg+xml;base64,' + btoa(svg);
    },
    getIconPath(iconName) {
      const paths = {
        'blind': 'M380.15 510.837a8 8 0 0 1-10.989-2.687l-125.33-206.427a31.923 31.923 0 0 0 12.958-9.485l126.048 207.608a8 8 0 0 1-2.687 10.991zM142.803 314.338l-32.54 89.485 36.12 88.285c6.693 16.36 25.377 24.192 41.733 17.501 16.357-6.692 24.193-25.376 17.501-41.734l-62.814-153.537zM96 88c24.301 0 44-19.699 44-44S120.301 0 96 0 52 19.699 52 44s19.699 44 44 44zm154.837 169.128l-120-152c-4.733-5.995-11.75-9.108-18.837-9.112V96H80v.026c-7.146.003-14.217 3.161-18.944 9.24L0 183.766v95.694c0 13.455 11.011 24.791 24.464 24.536C37.505 303.748 48 293.1 48 280v-79.766l16-20.571v140.698L9.927 469.055c-6.04 16.609 2.528 34.969 19.138 41.009 16.602 6.039 34.968-2.524 41.009-19.138L136 309.638V202.441l-31.406-39.816a4 4 0 1 1 6.269-4.971l102.3 129.217c9.145 11.584 24.368 11.339 33.708 3.965 10.41-8.216 12.159-23.334 3.966-33.708z',

        'wheelchair': 'M496.101 385.669l14.227 28.663c3.929 7.915.697 17.516-7.218 21.445l-65.465 32.886c-16.049 7.967-35.556 1.194-43.189-15.055L331.679 320H192c-15.925 0-29.426-11.71-31.679-27.475C126.433 55.308 128.38 70.044 128 64c0-36.358 30.318-65.635 67.052-63.929 33.271 1.545 60.048 28.905 60.925 62.201.868 32.933-23.152 60.423-54.608 65.039l4.67 32.69H336c8.837 0 16 7.163 16 16v32c0 8.837-7.163 16-16 16H215.182l4.572 32H352a32 32 0 0 1 28.962 18.392L438.477 396.8l36.178-18.349c7.915-3.929 17.517-.697 21.446 7.218zM311.358 352h-24.506c-7.788 54.204-54.528 96-110.852 96-61.757 0-112-50.243-112-112 0-41.505 22.694-77.809 56.324-97.156-3.712-25.965-6.844-47.86-9.488-66.333C45.956 198.464 0 261.963 0 336c0 97.047 78.953 176 176 176 71.87 0 133.806-43.308 161.11-105.192L311.358 352z',

        'truck': 'M624 352h-16V243.9c0-12.7-5.1-24.9-14.1-33.9L494 110.1c-9-9-21.2-14.1-33.9-14.1H416V48c0-26.5-21.5-48-48-48H48C21.5 0 0 21.5 0 48v320c0 26.5 21.5 48 48 48h16c0 53 43 96 96 96s96-43 96-96h128c0 53 43 96 96 96s96-43 96-96h48c8.8 0 16-7.2 16-16v-32c0-8.8-7.2-16-16-16zM160 464c-26.5 0-48-21.5-48-48s21.5-48 48-48 48 21.5 48 48-21.5 48-48 48zm320 0c-26.5 0-48-21.5-48-48s21.5-48 48-48 48 21.5 48 48-21.5 48-48 48zm80-208H416V144h44.1l99.9 99.9V256z',

        'stopwatch': 'M432 304c0 114.9-93.1 208-208 208S16 418.9 16 304c0-104 76.3-190.2 176-205.5V64h-28c-6.6 0-12-5.4-12-12V12c0-6.6 5.4-12 12-12h120c6.6 0 12 5.4 12 12v40c0 6.6-5.4 12-12 12h-28v34.5c37.5 5.8 71.7 21.6 99.7 44.6l27.5-27.5c4.7-4.7 12.3-4.7 17 0l28.3 28.3c4.7 4.7 4.7 12.3 0 17l-29.4 29.4-.6.6C419.7 223.3 432 262.2 432 304zm-176 36V188.5c0-6.6-5.4-12-12-12h-40c-6.6 0-12 5.4-12 12V340c0 6.6 5.4 12 12 12h40c6.6 0 12-5.4 12-12z',

        'paperclip': 'M43.246 466.142c-58.43-60.289-57.341-157.511 1.386-217.581L254.392 34c44.316-45.332 116.351-45.336 160.671 0 43.89 44.894 43.943 117.329 0 162.276L232.214 383.128c-29.855 30.537-78.633 30.111-107.982-.998-28.275-29.97-27.368-77.473 1.452-106.953l143.743-146.835c6.182-6.314 16.312-6.422 22.626-.241l22.861 22.379c6.315 6.182 6.422 16.312.241 22.626L171.427 319.927c-4.932 5.045-5.236 13.428-.648 18.292 4.372 4.634 11.245 4.711 15.688.165l182.849-186.851c19.613-20.062 19.613-52.725-.011-72.798-19.189-19.627-49.957-19.637-69.154 0L90.39 293.295c-34.763 35.56-35.299 93.12-1.191 128.313 34.01 35.093 88.985 35.137 123.058.286l172.06-175.999c6.177-6.319 16.307-6.433 22.626-.256l22.877 22.364c6.319 6.177 6.434 16.307.256 22.626l-172.06 175.998c-59.576 60.938-155.943 60.216-214.77-.485z',

        'taxi': 'M462 241.64l-22-84.84c-9.6-35.2-41.6-60.8-76.8-60.8H352V64c0-17.67-14.33-32-32-32H192c-17.67 0-32 14.33-32 32v32h-11.2c-35.2 0-67.2 25.6-76.8 60.8l-22 84.84C21.41 248.04 0 273.47 0 304v48c0 23.63 12.95 44.04 32 55.12V448c0 17.67 14.33 32 32 32h32c17.67 0 32-14.33 32-32v-32h256v32c0 17.67 14.33 32 32 32h32c17.67 0 32-14.33 32-32v-40.88c19.05-11.09 32-31.5 32-55.12v-48c0-30.53-21.41-55.96-50-62.36zM96 352c-17.67 0-32-14.33-32-32s14.33-32 32-32 32 14.33 32 32-14.33 32-32 32zm20.55-112l17.2-66.36c2.23-8.16 9.59-13.64 15.06-13.64h214.4c5.47 0 12.83 5.48 14.85 12.86L395.45 240h-278.9zM416 352c-17.67 0-32-14.33-32-32s14.33-32 32-32 32 14.33 32 32-14.33 32-32 32z',

        'car': 'M499.99 176h-59.87l-16.64-41.6C406.38 91.63 365.57 64 319.5 64h-127c-46.06 0-86.88 27.63-103.99 70.4L71.87 176H12.01C4.2 176-1.53 183.34.37 190.91l6 24C7.7 220.25 12.5 224 18.01 224h20.07C24.65 235.73 16 252.78 16 272v48c0 16.12 6.16 30.67 16 41.93V416c0 17.67 14.33 32 32 32h32c17.67 0 32-14.33 32-32v-32h256v32c0 17.67 14.33 32 32 32h32c17.67 0 32-14.33 32-32v-54.07c9.84-11.25 16-25.8 16-41.93v-48c0-19.22-8.65-36.27-22.07-48H494c5.51 0 10.31-3.75 11.64-9.09l6-24c1.89-7.57-3.84-14.91-11.65-14.91zm-352.06-17.83c7.29-18.22 24.94-30.17 44.57-30.17h127c19.63 0 37.28 11.95 44.57 30.17L384 208H128l19.93-49.83zM96 319.8c-19.2 0-32-12.76-32-31.9S76.8 256 96 256s48 28.71 48 47.85-28.8 15.95-48 15.95zm320 0c-19.2 0-48 3.19-48-15.95S396.8 256 416 256s32 12.76 32 31.9-12.8 31.9-32 31.9z'
      };

      return paths[iconName] || paths['car'];
    },
  },
  computed: {
    app_name: function () {
      return process.env.VUE_APP_NAME;
    },
    logo_url: function () {
      return require('@/assets/imgs/logos/' + process.env.VUE_APP_LOGO_NAME);
    },
    background_color: function () {
      return process.env.VUE_APP_COLOR;
    },
    markersList: function () {
      return this.markers;
    },
    polygonsList: function () {
      return this.polygons;
    },
    center: function () {
      return {
        lat: parseFloat(process.env.VUE_APP_DEFAULT_LAT),
        lng: parseFloat(process.env.VUE_APP_DEFAULT_LNG),
      };
    },
  }
}
</script>
<style scoped>
.div-terms {
  background: white;
  padding: 15px;
  border-radius: 15px;
  width: 100%;
}

.div-estar {
  background-color: white;
  margin: 0 auto;
  width: 100px;
  height: 100px;
  border-radius: 200px;
}

.logo-estar {
  height: 75px;
  margin: 13px auto;
  display: table;
}

.bg-qr-code {
  background-color: #003A73 !important;
}

i {
  color: #ffffff;
  font-size: 100px;
}

h2 {
  font-size: 34px;
  color: #ffffff;
  font-family: Roboto-Black;
}

h5 {
  font-family: Roboto-Black;
  font-size: 24px;
  color: #58595B;
}

p {
  font-size: 14px;
  color: #ffffff;
  font-family: Roboto-Regular;
  margin: 0;
}

@media only screen and (max-width: 768px) {
  * {
    text-align: center !important;
  }

  p {
    margin-top: 20px;
    margin-bottom: 5px;
  }
}

.btn:link,
.btn:visited {
  text-decoration: none;
  text-transform: uppercase;
  position: relative;
  top: 0;
  left: 0;
  padding: 20px 40px;
  border-radius: 100px;
  display: inline-block;
  transition: all .5s;
}

.btn-white {
  background: #fff;
  color: #000;
}

.btn:hover {
  box-shadow: 0px 10px 10px rgba(0, 0, 0, 0.2);
  transform: translateY(-3px);
}

.btn:active {
  box-shadow: 0px 5px 10px rgba(0, 0, 0, 0.2);
  transform: translateY(-1px);
}

.btn::after {
  content: "";
  text-decoration: none;
  text-transform: uppercase;
  position: absolute;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  border-radius: 100px;
  display: inline-block;
  z-index: -1;
  transition: all .5s;
}

.btn-white::after {
  background: #fff;
}

.btn-animation-1:hover::after {
  transform: scaleX(1.4) scaleY(1.6);
  opacity: 0;
}
</style>
